var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg360(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.4,
    height: 66.08,
    viewBox: "0 0 137.4 66.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_360",
    "data-name": 360,
    transform: "translate(-101.967 252.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(214.297 -233.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M0,0V3.051C10.4,6.156,16.8,10.3,16.8,14.671c0,7.027-16.5,13.015-39.615,15.3V36.9C4.951,34.159,25.07,26.07,25.07,16.519,25.07,9.866,15.308,3.922,0,0",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(172.929 -202.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M0,0C-.753.009-1.5.019-2.262.019-35.639.019-62.7-7.276-62.7-16.275c0-4.767,7.595-9.262,19.7-12.435v-2.937c-16.959,3.894-27.962,10.157-27.962,17.22,0,11.811,30.758,21.386,68.7,21.386.759,0,1.509-.011,2.262-.018v9.29L13.057,3.174,0-9.883Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(141.433 -224.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M0,0C-2.624,0-4.373-1.29-6.076-2.993l-4.695,4.879c1.794,2.67,6.352,5.2,10.725,5.2C6.169,7.088,12.7,3.775,12.7-3.04a9.256,9.256,0,0,0-4.281-7.548c1.2-.92,3.405-2.716,3.405-5.846,0-5.891-4.234-9.758-11.737-9.758a14.847,14.847,0,0,0-9.851,4.373l4.466,5.385A7.982,7.982,0,0,1,.092-19.2c1.933,0,4.051,1.151,4.051,3.637,0,2.072-1.7,3.176-3.912,3.176H-3.13v5.478H.322c2.3,0,3.821.875,3.821,3.36C4.143-1.244,2.578,0,0,0",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(168.957 -217.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M0,0C7.5-.232,11.921-5.479,11.921-11.646A10.064,10.064,0,0,0,1.15-21.912a9.641,9.641,0,0,0-6.03,2.348c.461-3.406,2.624-6.168,6.03-6.261,2.809,0,5.157,1.428,6.721,2.348L11-29.46C8.286-31.762,3.222-33.189.138-33.1-11.968-32.729-13.533-20.53-13.4-14.408-13.119-5.2-7.549.229,0,0M-.046-15.282c2.761-.047,3.682,2.3,3.729,4.1A4.016,4.016,0,0,1-.507-7.227c-2.946,0-4.28-3.13-4.28-5.433A7.087,7.087,0,0,1-.046-15.282",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(208.449 -233.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M0,0C0-10.174-4.189-16.848-13.211-16.848c-7.641,0-12.981,6.767-12.981,16.526,0,11.323,5.524,16.8,13.211,16.8C-4.65,16.478,0,10.217,0,0M-17.078-.322c0-5.617,2.118-9.162,3.821-9.115,2.255,0,4,3.958,4,9.437,0,5.615-1.611,9.344-3.728,9.344-1.842,0-4.1-3.729-4.1-9.666",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(215.155 -240.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M0,0A5.913,5.913,0,0,0,5.912-5.913,5.913,5.913,0,0,0,0-11.826,5.913,5.913,0,0,0-5.914-5.913,5.913,5.913,0,0,0,0,0M0-9.03A3.117,3.117,0,0,1,3.116-5.913,3.117,3.117,0,0,1,0-2.8,3.116,3.116,0,0,1-3.117-5.913,3.117,3.117,0,0,1,0-9.03",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg360);
export default __webpack_public_path__ + "static/media/360.5dd78d193e5c84aa3ffb13a27b2ece13.svg";
export { ForwardRef as ReactComponent };